<section class="recurring-payments-details-card">
  <div class="responsive-card-title" i18n>Recurring Payment Details</div>

  <div class="d-flex flex-column gap-3">
    <app-vb-payments-recurring-payment-card
      *ngIf="monthlyPaymentData$ | async as monthlyData"
      cardTitle="Monthly Payment"
      i18n-cardTitle
      [cardData]="monthlyData"
      frequencyLabel="/ mo"
      i18n-frequencyLabel />

    <app-vb-payments-recurring-payment-card
      *ngIf="annualPaymentData$ | async as annualData"
      cardTitle="Annual Payment"
      i18n-cardTitle
      [cardData]="annualData"
      frequencyLabel="/ yr"
      i18n-frequencyLabel />
  </div>
</section>
